<script setup lang="ts">
const props = defineProps<{
  startsAt: Date;
  lastsUntil?: Date;
}>();

const slots = defineSlots<{
  default(): any;
  promotion(): any;
}>();

const now = ref(new Date());
const isOffered = computed(
  () =>
    now.value > props.startsAt &&
    (props.lastsUntil === undefined || now.value < props.lastsUntil)
);

const render = computed(() =>
  isOffered.value ? slots.promotion : slots.default
);
</script>

<template>
  <render />
</template>
